import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import Popup from './Popup';

class ScreenContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tsAndCsHidden: true
    }
    this.showTsAndCs = this.showTsAndCs.bind(this);
    this.showPrivacyPolicy = this.showPrivacyPolicy.bind(this);
  }

  showPrivacyPolicy(event) {
    event.preventDefault();
    this.setState(
      { 
        tsAndCsHidden: false,
        tAndCsTitle: this.props.data.textResources.PrivacyLinkText,
        tAndCsText: '<iframe src="'+this.props.data.uiSpec.PrivacyLink+'" style="border: 0; width: 100%;height: 100%;"/>'
      });
  }

  showTsAndCs(event) {
    event.preventDefault();
    this.setState(
      { 
        tsAndCsHidden: false,
        tAndCsTitle: this.props.data.textResources.TermsAndConditionsLinkText,
        tAndCsText: '<iframe src="'+this.props.data.uiSpec.TermsAndConditionsLink+'" style="border: 0; width: 100%;height: 100%;"/>'
      });
  }

  render() {
    let textResources = this.props.data.textResources;
    let uiSpec = this.props.data.uiSpec;
    return (
      <div>
        <div className="c-ColorStrip"></div>
        <div className="o-pageContainer">
          <div className="c-ContentContainer">
            {this.props.children}
          </div>
        </div>
        <div className="c-Footer">
          <div className="c-Footer-container">
            {uiSpec && uiSpec.PrivacyLink ? <a href="#" onClick={this.showPrivacyPolicy}>{textResources.PrivacyLinkText}</a> : ""}
            <p>{textResources.MessageAndDataText}</p>
            {uiSpec && uiSpec.TermsAndConditionsLink ? <a  href="#" onClick={this.showTsAndCs}>{textResources.TermsAndConditionsLinkText}</a> : ""}
          </div><br />
        </div>
        <Popup title={this.state.tAndCsTitle} text={this.state.tAndCsText} hidden={this.state.tsAndCsHidden} closeButtonText={this.props.data.textResources.tAndCsBack} hide={() => this.setState({ tsAndCsHidden: true })} />
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return {
  };
}

function mapStateToProps(state) {
  return {
    data: state.screen
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScreenContainer);


/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/Subcomponents/ScreenContainer.js
 **/